"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.approvalActOnResponseSchema = exports.approvalActOnRequestSchema = exports.approvalActOnAcknowledgmentSchema = exports.APPROVAL_ACT_ON_ACKNOWLEDGED_IDS_MAX = exports.APPROVAL_ACT_ON_COMMENT_MAX = exports.approvalActOnVerbSchema = exports.APPROVAL_ACT_ON_VERBS = void 0;
exports.approvalActOnAcknowledgmentRefusedMessage = approvalActOnAcknowledgmentRefusedMessage;
const zod_1 = require("zod");
const approval_rules_1 = require("./approval-rules");
const approval_inbox_1 = require("./approval-inbox");
exports.APPROVAL_ACT_ON_VERBS = ['approve', 'reject', 'request_changes'];
exports.approvalActOnVerbSchema = zod_1.z.enum(exports.APPROVAL_ACT_ON_VERBS);
exports.APPROVAL_ACT_ON_COMMENT_MAX = 4000;
// An upper bound on the id lists an acknowledgment may carry. It is a denial-of-
// service bound, not a domain rule: no order comes near it, and a body that does
// is malformed rather than unusual.
exports.APPROVAL_ACT_ON_ACKNOWLEDGED_IDS_MAX = 500;
const acknowledgedIdSchema = zod_1.z.string().regex(/^\d+$/, 'An acknowledged id must be a numeric id');
// What the approver ticked: the ids of the records the surface showed them.
// Only entity types that declare an acknowledgment accept it; every other type
// refuses a body carrying one, so a payload can never be silently dropped.
exports.approvalActOnAcknowledgmentSchema = zod_1.z
    .object({
    invoice_ids: zod_1.z.array(acknowledgedIdSchema).max(exports.APPROVAL_ACT_ON_ACKNOWLEDGED_IDS_MAX),
    payment_ids: zod_1.z.array(acknowledgedIdSchema).max(exports.APPROVAL_ACT_ON_ACKNOWLEDGED_IDS_MAX),
})
    .strict();
// The refusal when an acknowledgment reaches an entity type that declares none.
// Dropping it silently would let a caller believe a control ran that did not.
function approvalActOnAcknowledgmentRefusedMessage(entityType) {
    return `An acknowledgment is not accepted on a ${entityType} approval.`;
}
exports.approvalActOnRequestSchema = zod_1.z
    .object({
    action: exports.approvalActOnVerbSchema,
    role: approval_rules_1.pgApproverRoleSchema,
    comment: zod_1.z.string().trim().max(exports.APPROVAL_ACT_ON_COMMENT_MAX).optional(),
    acknowledgment: exports.approvalActOnAcknowledgmentSchema.optional(),
})
    .strict()
    .superRefine((value, ctx) => {
    if (value.action === 'approve')
        return;
    const comment = value.comment ?? '';
    if (comment.length === 0) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ['comment'],
            message: 'Comment is required for Reject and Request Changes',
        });
    }
});
exports.approvalActOnResponseSchema = zod_1.z.object({
    workflow_id: zod_1.z.string().uuid(),
    entity_type: approval_rules_1.approvalEntityTypeSchema,
    entity_id: zod_1.z.string(),
    approval_status: approval_inbox_1.approvalInboxStatusSchema,
    resolved: zod_1.z.boolean(),
    cycle: zod_1.z.number().int().min(1),
});
//# sourceMappingURL=approval-act-on.js.map